import { Link } from "react-router-dom";
import { href, COMPANY, CONTACTS } from "../content/shared";
import { useT } from "../i18n";
import { Logo } from "./Brand";
import { StoreBadges } from "./kit";

export default function Footer({ onCookies }) {
  const { lang, t } = useT();
  const f = t.footer;
  const cols = [
    [f.colProduct, [["product", t.nav.product], ["how", t.nav.how], ["useCases", t.nav.useCases], ["pricing", t.nav.pricing], ["download", t.nav.download]]],
    [f.colCompany, [["about", t.nav.about], ["safety", t.nav.safety], ["help", t.nav.help], ["support", t.nav.support]]],
    [f.colLegal, [["privacy", f.privacy], ["terms", f.terms], ["child", f.child], ["impressum", f.impressum], ["deletion", f.deletion]]],
  ];
  return (
    <footer className="border-t border-border bg-surface" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 lg:grid-cols-[1.3fr_2fr]">
        <div>
          <Logo />
          <p className="mt-4 max-w-sm text-sm text-muted-foreground">{f.tagline}</p>
          <StoreBadges className="mt-6" prefix="footer" />
        </div>
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
          {cols.map(([title, links]) => (
            <div key={title}>
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground">{title}</p>
              <ul className="mt-4 space-y-2.5">
                {links.map(([k, label]) => (
                  <li key={k}><Link to={href(lang, k)} className="text-sm hover:text-primary" data-testid={`footer-link-${k}`}>{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="container-x flex flex-col gap-3 border-t border-border py-6 text-xs text-muted-foreground md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} {COMPANY.name} · {COMPANY.street}, {COMPANY.city}, {COMPANY.country} · <a className="hover:text-primary" href={`mailto:${CONTACTS.support}`}>{CONTACTS.support}</a></p>
        <button type="button" onClick={onCookies} className="self-start text-left hover:text-primary md:self-auto" data-testid="footer-cookie-settings">{f.cookies}</button>
      </div>
    </footer>
  );
}
